module.exports = __webpack_public_path__ + "static/media/left.d045bdc1.svg";